import { useSortable } from "@dnd-kit/sortable"
import {CSS} from "@dnd-kit/utilities"

const DndImage = ({id, imageurl, onImageDelete}) => {

    const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id})
    const style = {
        transform: CSS.Transform.toString(transform)
    }

    const handleClick = (e) => {
        console.log(e.target)
    }
    
    return (
        <div 
        // key={`edit-images-box-${i}`}
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="edit-images-box" 
        >
            <div onClick={onImageDelete} imageurl={imageurl} className="x-delete-button">
                <div className="x-container" imageurl={imageurl}></div>
            </div>
            <img className="edit-images-thumbnail" src={imageurl}/>
        </div>
    )
}

export default DndImage